// assets
import MailOutlined from '@ant-design/icons/MailOutlined';

const icons = { MailOutlined };

// ==============================|| MENU ITEMS - EMAILS SENT (Michael + AI only) ||============================== //

const emailsSent = {
  id: 'emails-sent',
  title: 'Emails Sent',
  type: 'item',
  url: '/emails-sent',
  icon: icons.MailOutlined,
  devOnly: true
};

export default emailsSent;
